/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Text, useColorModeValue ,Menu,MenuButton,MenuList,Flex } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { currencyFormate } from "jsFunctions/helperFunctions";
import ExportDataModel from "components/exportData/ExportDataModel";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import GstInfoModel from "components/models/GstInfoModel";
import { FaEllipsisV } from "react-icons/fa";
import { CiExport } from "react-icons/ci";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { gstDataColumns } from "./embrillTable/variables/colData";
import { fetchAsyncSearchGstData } from "redux/slices/gstSlice";
import RecordTable from "./InvoiceRecords/RecordTable/RecordTable";
import moment from "moment";

const EmbrillGst = () => {
  const [gstListData, setGstListData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [openGstInfoModel, setOpenGstInfoModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const currUser = useSelector((state) => state.auth.currUser);
  const [role,setRole] = useState('')  

  useEffect(()=>{
    if(currUser && currUser?.auth){
      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Gst');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
  },[currUser])

  const gstData = useSelector((state) => state.gstData);
  const dispatch = useDispatch();
 
  useEffect(() => {
    setLoading(true); 
    dispatch(fetchAsyncSearchGstData({}))
      .then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false); 
      });
  }, []);

  useEffect(() => {
    if (gstData?.gstData && gstData?.gstData.length > 0) {
      const tableData = gstData?.gstData.map((data, index) => {
        return {
          _id:data._id,
          no: index + 1,
          poNo: (
            <span 
              style={{ cursor: "pointer",color:'blue'}}
            >
              {data.poNo ? poNumberFormate(data.poNo) : "-"}
            </span>
          ),
          vendorName: <span>{data?.gstFields?.vendorName || "-"}</span> ,
          gstNumber: data?.gstFields?.gstNumber,
          sortBaseAmt:data?.gstFields?.baseAmount || 0,
          baseAmount:(
            <span>

              {data?.gstFields?.baseAmount ? currencyFormate(data?.gstFields?.baseAmount ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          sortIgstAmt:Number(data?.gstFields?.gstAmount?.i || 0),
          igstAmt: (
            <span>

              {data?.gstFields?.gstAmount?.i ? currencyFormate(data?.gstFields?.gstAmount?.i ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          sortSgstAmt:Number(data?.gstFields?.gstAmount?.s || 0),
          sgstAmt: (
            <span>

              {data?.gstFields?.gstAmount?.s ? currencyFormate(data?.gstFields?.gstAmount?.s ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          sortCgstAmt:Number(data?.gstFields?.gstAmount?.c || 0),
          cgstAmt: (
            <span>

              {data?.gstFields?.gstAmount?.c ? currencyFormate(data?.gstFields?.gstAmount?.c ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
          sortTlAmt:Number(data?.gstFields?.totalGst|| 0),

          totalGst: (
            <span>

              {data?.gstFields?.totalGst ? currencyFormate(data?.gstFields?.totalGst ): <div dangerouslySetInnerHTML={{ __html: `<span style="font-family: sans-serif">₹</span> ${Number(0).toFixed(2)}`}}/>}
            </span>
          ),
         
          date: moment(data.om).format('yyyy-MM'),
          
        };
      });
      setGstListData(tableData);
    } else {
      setGstListData([]);
    }
  }, [gstData]);

  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const array = gstData?.gstData || [];
    const data = array?.filter((item)=> item?._id === _id)
    setSelectedItem(data[0]);
    setOpenGstInfoModel(true);
  }

  const closeGstInfoModel = () => {
    setOpenGstInfoModel(false);
    setSelectedItem({});
  };
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  let menuBg = useColorModeValue("white", "navy.800");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const [isOpen, setIsOpen] = useState(false);
  const [activeBtn,setActiveBtn] = useState("")

  const toggleMenu = (btn) => {
    setIsOpen(!isOpen);
    setActiveBtn(btn)
  };
  const handleClose = () => {   
    setActiveBtn("");   
    setIsOpen(false)
  };

  // If loading, return a spinner
  if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
       <Box  display="flex" className="mx-3" justifyContent="space-between">
       <Box display="flex">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
        >
          Goods And Services Tax (GST)
        </Text>
       
        </Box>
        <Box display="flex" mt={2} className="add-new-btn">
        <Box>
          <Menu>
          <MenuButton p="0px">
          <Box  className='menu-ellipsis-btn'><FaEllipsisV /></Box>

          </MenuButton>
          <MenuList
             boxShadow={shadow}
             p="0px"
             mt="10px"
             borderRadius="10px"
             bg={menuBg}
             border="none"
          >
            <Flex w="100%" mb="0px" flexDirection="column">
            <Box
                ps="20px"
                pt="10px"
                pb="8px"
                className="menu-text"
                borderBottom="1px solid gray"
                borderColor={borderColor}
                onClick={()=>toggleMenu('xlsx')}
                display="flex"
               
              >
                <CiExport size={20} className="mx-1"/> <span>Export XLSX</span>
                
              </Box>
             
            </Flex>
            <Flex w="100%" mb="0px" flexDirection="column">
            
            </Flex>
           <Box marginRight={40}>
           {isOpen && (
            <ExportDataModel
              filename={"Gst_"}
              type="gst"
              role={role}
              isOpen={isOpen}
              handleClose={handleClose}
              activeBtn={activeBtn}
            />
          )}
           </Box>
          </MenuList>
        </Menu>
          </Box>
        </Box>
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <RecordTable
          columnsData={gstDataColumns}
          tableData={gstListData}
          type={"gst"}
          role={role}
          expenseType = 'gst'
          gstRecords={gstData}
          openInfoModal = {handleRowClick}
        />
      </Box>
      {openGstInfoModel && (
        <GstInfoModel
          openInfoModal={openGstInfoModel}
          closeInfoModal={closeGstInfoModel}
          selectedItem={selectedItem}   
          role={role}
     
        />
      )}
    </>
  );
};

export default EmbrillGst;
